var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canAssegnaAct
    ? _c(
        "div",
        { staticClass: "panoramica-assegna-actions" },
        [
          _c("v-select", {
            staticClass: "panoramica-assegna-select",
            attrs: {
              items: _vm.squadreDropdown,
              "item-text": "name",
              "item-value": "id",
              "item-disabled": "disabled",
              "menu-props": { contentClass: "asta-assegna-squadre-menu" },
              dense: "",
              outlined: "",
              "hide-details": "",
              dark: "",
              label: "Squadra",
              "no-data-text": "Nessuna squadra disponibile",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "selection",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticClass: "squadra-dropdown-selection" },
                        [
                          _c(
                            "v-avatar",
                            { staticClass: "mr-1", attrs: { size: "25" } },
                            [_c("img", { attrs: { src: item.pic } })]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "squadra-dropdown-name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("v-list-item-avatar", [
                        _c("img", { attrs: { src: item.pic } }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        { staticClass: "squadra-dropdown-item-content" },
                        [
                          _c("v-list-item-title", {
                            staticClass: "squadra_name squadra-option-name",
                            domProps: { textContent: _vm._s(item.name) },
                          }),
                          _vm._v(" "),
                          item.disabledReason
                            ? _c(
                                "v-list-item-subtitle",
                                { staticClass: "squadra-disabled-reason" },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(item.disabledReason) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              344541378
            ),
            model: {
              value: _vm.selected,
              callback: function ($$v) {
                _vm.selected = $$v
              },
              expression: "selected",
            },
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "panoramica-assegna-costo",
            attrs: {
              value: _vm.offerta,
              dense: "",
              outlined: "",
              readonly: "",
              "hide-details": "",
              dark: "",
              label: "Costo",
              "append-icon": "edit",
            },
            on: {
              click: function ($event) {
                return _vm.showNumpad()
              },
              "click:append": function ($event) {
                return _vm.showNumpad()
              },
              keydown: function ($event) {
                $event.preventDefault()
              },
            },
          }),
          _vm._v(" "),
          _vm.canAnnullaSelezione
            ? _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    text: "",
                    rounded: "",
                    color: "white",
                    loading: _vm.processingAnnulla,
                    disabled: _vm.processing,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.annullaSelezione()
                    },
                  },
                },
                [_vm._v("\n    Annulla\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                large: "",
                outlined: "",
                rounded: "",
                color: "white",
                disabled: _vm.processing,
              },
              on: {
                click: function ($event) {
                  return _vm.scarta()
                },
              },
            },
            [_vm._v("\n    Scarta\n  ")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "navy--text",
              attrs: {
                large: "",
                rounded: "",
                color: "accent",
                loading: _vm.loading,
                disabled:
                  _vm.selected == null ||
                  _vm.offerta == null ||
                  _vm.squadraDisabled(_vm.selected),
              },
              on: {
                click: function ($event) {
                  return _vm.assegna()
                },
              },
            },
            [_vm._v("\n    Assegna\n  ")]
          ),
          _vm._v(" "),
          _c(
            "v-alert",
            {
              staticClass: "panoramica-assegna-error mb-0",
              attrs: { dense: "", text: "", color: "error" },
              model: {
                value: _vm.error,
                callback: function ($$v) {
                  _vm.error = $$v
                },
                expression: "error",
              },
            },
            [
              _vm._v(
                "\n    Offerta " +
                  _vm._s(_vm.errorValue) +
                  " non valida. Min: " +
                  _vm._s(_vm.minOfferta) +
                  " - Max:\n    " +
                  _vm._s(_vm.maxOfferta) +
                  "\n  "
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }